var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown nodro item" }, [
    _c(
      "button",
      {
        staticClass: "btn no-bg text-secondary",
        attrs: { type: "button" },
        on: { click: _vm.onClick }
      },
      [
        _vm.icon ? _c("i", { class: [_vm.icon, _vm.iconClassName] }) : _vm._e(),
        _vm._v(" "),
        _c("span", { class: [_vm.textClassName] }, [
          _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb9f225", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb9f225","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseAction.vue
// module id = null
// module chunks = 